<template>
  <div class="acomodar">
    <div class="container-fluid py-4 px-4">

      <div class="border border-1 rounded-3 p-3 mb-3">
        <div class="row g-2">
          <div class="col-12 reducirTamaño label-resaltado">
            <label>LEYENDA</label>
          </div>

          <div class="col-12 col-sm-6 col-md-2 label-resaltado">
            <i class="bi bi-toggle-on fs-7"> Estado activado</i>
          </div>

          <div class="col-12 col-sm-6 col-md-2 label-resaltado">
            <i class="bi bi-toggle-off fs-7"> Estado desactivado</i>
          </div>

          <div class="col-12 col-sm-6 col-md-2 label-resaltado">
            <i class="bi bi-pencil fs-7"> Editar los campos</i>
          </div>
          <div class="col-12 col-sm-6 col-md-2 label-resaltado">
            <i class="bi bi-copy fs-7"> Copiar portapapeles</i>
          </div>
          <div class="col-12 col-sm-6 col-md-2 label-resaltado">
            <i class="bi bi-trash3 fs-7">Eliminar toda la fila</i>
          </div>
        </div>
      </div>



      <div class="card shadow-sm mb-3">
        <div class="card-body">

          <form @submit.prevent="GuardarModulo">

            <h5 class="fw-bold text-center mb-1">CREACIÓN DE MÓDULO</h5>

            <div class="text-end">

              <label class="text-center fw-semibold d-block">Icono del Módulo</label>

              <div class="row g-1 mt-1 mb-2 justify-content-end icon-grid-limit flex-row-reverse">

                <div v-for="icon in icons" :key="icon.nomIcono" class="col-auto p-1 icono-box icon-small"
                  @click="selectIcon(icon.nomIcono, icon.idIcono)" :class="{
                    'border-primary shadow selected-icon': icon.nomIcono === selectedIcon
                  }" style="cursor:pointer; min-width:55px;">

                  <div class="border rounded-3 py-2 d-flex justify-content-center align-items-center"
                    style="transition:0.2s;">
                    <i :class="icon.nomIcono" class="fs-7"></i>
                  </div>
                </div>
              </div>



              <p class="fw-bold text-start mt-2">
                ICONO SELECCIONADO:
                <i :class="selectedIcon" class="ms-1 fs-7"></i>
              </p>
            </div>
            <small class="text-secondary text-start d-block mb-4">
              Clasificación de primer nivel
            </small>

            <div class="row mt-3">
              <div class="col-12 col-md-4">


                <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                  <i class="bi bi-building text-secondary fs-6"></i> NOMBRE
                </label>
                <div class="d-flex">

                  <input type="text" class="form-control py-2" placeholder="Ingresar nombre del módulo"
                    v-model="nombreModulo" required />


                  <button class="btn btn-success d-flex justify-content-center align-items-center ms-2"
                    style="width: 48px; height: 48px;">
                    <i class="bi bi-save fs-6"></i>
                  </button>

                </div>

              </div>
            </div>


          </form>

        </div>
      </div>



      <div class="border border-1 rounded-3 p-3 mb-3">
        <TablaModulo />
      </div>



      <div class="col-12">
        <hr class="mx-2" />
      </div>




      <div class="card shadow-sm mb-3">
        <div class="card-body">
          <form @submit.prevent="GuardarCategoria">

            <h5 class="fw-bold text-center mb-1">CREACIÓN DE CATEGORÍA</h5>



            <label class="text-secondary fw-bold">Icono de la Categoría</label>

            <div class="row g-1 mt-1 mb-2 justify-content-end icon-grid-limit flex-row-reverse">

              <div v-for="icon in icons" :key="icon.nomIcono" class="col-auto p-1 icono-box icon-small"
                @click="selectIconCategoria(icon.nomIcono, icon.idIcono)" :class="{
                  'border-primary shadow selected-icon':
                    icon.nomIcono === selectedIconCategoria
                }" style="cursor:pointer; min-width:48px; max-width:48px;">

                <div class="border rounded-3 py-1 d-flex justify-content-center align-items-center"
                  style="transition:0.2s; width:100%; min-height:38px;">
                  <i :class="icon.nomIcono" class="fs-6"></i>
                </div>
              </div>
            </div>

            <p class="text-start mt-1 mb-3 fw-bold">
              ICONO SELECCIONADO:
              <i :class="selectedIconCategoria" class="ms-1"></i>
            </p>
            <small class="text-secondary text-start d-block mb-4">
              Clasificación de segundo nivel
            </small>
            <div class="row g-3">

            
              <div class="col-12 col-md-4">
                <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                  <i class="bi bi-tags-fill text-secondary fs-5"></i>
                  NOMBRE DE LA CATEGORÍA
                </label>
                <input type="text" class="form-control py-2" placeholder="Ingrese nombre..." v-model="nombreCategoria"
                  required />
              </div>

          
              <div class="col-12 col-md-4">
                <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                  <i class="bi bi-chat-square-dots text-secondary fs-5"></i>
                  DESCRIPCIÓN (LINK POWER BI)
                </label>
                <input type="text" class="form-control py-2" v-model="descripcionLinkBI" required />
              </div>

            
              <div class="col-12 col-md-4 position-relative">
                <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                  <i class="bi bi-collection text-secondary fs-5"></i> MÓDULO:
                </label>

                <input type="text" class="form-control text-secondary" v-model="busquedaModulo"
                  placeholder="Escriba el nombre del módulo..." @input="filtrarModulos" @blur="ocultarListaModulos" />

                <ul v-if="mostrarListaModulos && modulosFiltrados.length"
                  class="list-group position-absolute w-100 mt-1 shadow-sm"
                  style="z-index: 2000; max-height: 200px; overflow-y: auto;">
                  <li v-for="mod in modulosFiltrados" :key="mod.idModulo" class="list-group-item list-group-item-action"
                    @mousedown.prevent="seleccionarModulo(mod)">
                    {{ mod.nomModulo }}
                  </li>
                </ul>
              </div>


             
              <div class="col-12 col-md-4">
                <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                  <i class="bi bi-bookmark-check text-secondary fs-5"></i>
                  PRIORIDAD DE ORDEN
                </label>
                <input type="text" class="form-control py-2" v-model="catOrden" required />
              </div>

        
              <div class="col-12 col-md-4">
                <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                  <i class="bi bi-clipboard2-heart-fill fs-5"></i>
                  DETALLE CATEGORÍA
                </label>
                <input type="text" class="form-control py-2" v-model="catDetalle" required />
              </div>

            
              <div class="col-12 col-md-4 d-flex align-items-end">
               <button class="btn btn-success d-flex justify-content-center align-items-center ms-2"
                    style="width: 48px; height: 48px;">
                    <i class="bi bi-save fs-6"></i>
                  </button>
              </div>

            </div>

          </form>
        </div>
      </div>


          <div class="border border-1 rounded-3 p-3 mb-3">
          <TablaCategoria />
        </div>

      

    </div>
  </div>


</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert";
import Swal2 from "sweetalert2";
import TablaCategoria from "@/components/Configuracion/Tablas/tablaCategoria.vue";
import TablaModulo from "@/components/Configuracion/Tablas/tablaModulo.vue";
export default {
  name: "PowerbyConfiguracion",
  components: { TablaModulo, TablaCategoria },

  data() {
    return {
      nombreModulo: "",
      selectedIcon: "ninguno",
      selectedIconCategoria: "ninguno",

      icons: [],
      idIcono: "5",
      idIconoCategoria: "5",
      idUsuario: "",

      // PARA EL BUSCADOR DE MÓDULOS
      busquedaModulo: "",
      mostrarListaModulos: false,
      modulosFiltrados: [],

      idModulo: "",
      nombreCategoria: "",
      descripcionLinkBI: "",
      perfilNombre: "",
      cambiarPermisos: true,
      catOrden: "",
      catDetalle: "",
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
    this.axios.get(`BIClientes/ListadoIconos`).then((r) => {
      console.log(r.data);
      this.icons = r.data;
    });
  },

  created() {
    this.ListarCategorias();
  },

  computed: {
    ...mapGetters("acciones", ["ListaModulos", "ListaCategorias"]),
  },

  methods: {
    ...mapActions("acciones", ["ListarModulo", "ListarCategorias"]),

    GuardarModulo() {
      const from = {
        idUsuario: this.idUsuario,
        idIcono: this.idIcono,
        nomModulo: this.nombreModulo,
      };
      console.log(from);
      this.axios.post(`BIClientes/RegistrarModulo`, from).then((r) => {
        console.log(r.data);

        if (r.data) {
          this.ListarModulo();
          Swal(`Se registró el módulo ${this.nombreModulo}`, "", "success");
          this.idIcono = "5"
          this.nombreModulo = "";
          this.selectedIcon = "";
        }
      });
    },

    selectIcon(iconClass, id) {
      this.selectedIcon = iconClass;
      this.idIcono = id;
    },

    selectIconCategoria(iconClass, id) {
      this.selectedIconCategoria = iconClass;
      this.idIconoCategoria = id;
    },

    GuardarCategoria() {
      // Extraer Group ID y Report ID del link Power BI
      const regex = /groups\/([a-z0-9-]+)\/reports\/([a-z0-9-]+)/;
      const match = this.descripcionLinkBI.match(regex);

      // Definir groupId y reportId
      let grupoid = "";
      let reporteid = "";

      if (match) {
        grupoid = match[2]; // Extraer el Group ID
        reporteid = match[1]; // Extraer el Report ID
        console.log("Group ID:", grupoid);
        console.log("Report ID:", reporteid);
      } else {
        console.log("El link de Power BI no es válido.");
      }

      const from = {
        idUsuario: this.idUsuario,
        idIcono: this.idIconoCategoria,
        idModulo: this.idModulo,
        catNombre: this.nombreCategoria,
        linkBI: this.descripcionLinkBI,
        catOrden: this.catOrden,
        catDetalle: this.catDetalle,
        grupoid: grupoid, // Ahora se asigna el valor correcto
        reporteid: reporteid, // Ahora se asigna el valor correcto
      };

      console.log(from);
      this.axios.post(`BIClientes/RegistrarCategoria`, from).then((r) => {
        console.log(r.data);
        if (r.data) {
          this.ListarModulo();
          Swal(
            `Se registró la categoría ${this.nombreCategoria}`,
            "",
            "success"
          );
          this.nombreCategoria = "";
          this.selectedIcon = "";
          this.descripcionLinkBI = "";
          this.catOrden = "";
          this.detalleCategoria = "";
          this.ListarCategorias();
        }

        if (!r.data) {
          Swal2.fire({
            icon: "error",
            title: `LA CATEGORIA ${this.nombreCategoria} YA SE ENCUENTRA ASOCIADA A ESTE MODULO`,
            text: "",
            footer: "",
          });
        }
      });
    },
    filtrarModulos() {
      const texto = this.busquedaModulo.trim().toLowerCase();

      // Mostrar lista si hay texto
      this.mostrarListaModulos = texto.length > 0;

      // Filtrar módulos desde Vuex
      this.modulosFiltrados = this.ListaModulos.filter((mod) =>
        mod.nomModulo.toLowerCase().includes(texto)
      );
    },

    seleccionarModulo(mod) {
      this.busquedaModulo = mod.nomModulo;
      this.idModulo = mod.idModulo; // ← lo que luego usas para registrar categoría
      this.mostrarListaModulos = false;
    },

    ocultarListaModulos() {
      setTimeout(() => {
        this.mostrarListaModulos = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 9px;
  margin-bottom: 8px;
  padding-bottom: 5%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 0.25%;
  margin-right: 10px;

  border-radius: 10px;
  /* QUITAR ESTOS DOS ↓↓↓ */
  /* height: 100vh; */
  /* overflow-y: auto; */

  /* Dejar solo si quieres evitar barra horizontal */
  overflow-x: hidden;
}


.b-modal .modal-header button.close {
  display: none;
}

.bg-solimano {
  text-align: center;
  background: #0080c8;
}

strong {
  font-size: 1.64rem;
  color: black;
}

.letra {
  font-weight: 600;
}

/* .icon-selector {
  display: flex;
  gap: 10px;
} */
.bg-iconos {
  background: #f7f7f7;
}

.icon-selector div {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 2px;
}

.icon-selector div.selected {
  border-color: #007bff;
  /* Color de borde al seleccionar */
}

.icon-selector i {
  font-size: 24px;
  /* Tamaño de los iconos */
}

/* Caja de icono */
.icon-box {
  border: 1px solid #e3e3e3;
  padding: 12px;
  border-radius: 10px;
  cursor: pointer;
  background: #f8f9fa;
  transition: all 0.2s ease;
}

/* Hover */
.icon-box:hover {
  background: #e9ecef;
  transform: scale(1.05);
}

/* Seleccionado */
.icon-box.selected {
  border: 2px solid #0d6efd;
  background: #e7f1ff;
  transform: scale(1.07);
}
.no-overflow {
  overflow-x: hidden !important;
}
</style>
